import React from "react";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import ConcepcaoContent from "components/ConcepcaoContent";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import routes from "routes"; // ajuste o caminho se necessário
import footerRoutes from "footer.routes"; // ajuste o caminho se necessário

function Outrasconcepcoes() {
  return (
    <>
      {/* Navbar padrão */}
      <DefaultNavbar routes={routes} sticky />

      {/* Conteúdo da página */}
      <MKBox component="section" py={6}>
        <Container>
          <ConcepcaoContent />
        </Container>
      </MKBox>

      {/* Rodapé padrão */}
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Outrasconcepcoes;
